import React from 'react';
import { useLocation } from 'react-router';
import Footer from 'Components/Footer';
import Header from 'Components/Header';

import SidebarSubLayout from './sublayouts/SidebarSubLayout';

function BasePathWrapper() {
  const location = useLocation();

  return (
    <div className="main-layout">
      <Header location={location} />
      <SidebarSubLayout />
      <Footer />
    </div>
  );
}

export default BasePathWrapper;
